import {
    APP_SET_GEO_INFORMATION,
    APP_SET_PAGE_ERROR,
    APP_SET_QUERY_STRING_TO_STATE,
    APP_SET_TRANSLATOR,
    APP_SET_USER_DETAILS,
    APP_SET_SIGNED_OUT,
    APP_SET_DYNAMIC_CONTENT,
    APP_SET_IS_CHROME_INCOGNITO,
    APP_SET_CENTRAL_CONFIG,
    SET_ICON_SOURCE,
    // GET_AB_TEST_CONFIG,
    // GET_AB_TEST_CONFIG_FULFILLED,
    // GET_AB_TEST_CONFIG_NEWSIGNUP_FULFILLED,
    SET_UPDATE_PASSWORD,
    SET_SOCIAL_ERROR,
    RESET_SOCIAL_ERROR,
    SET_SOCIAL_LOGIN_IN_PROGRESS,
    SET_EXPIREDLINK_POPUP,
    SET_MIGRATEDLINK_POPUP,
    PASSWORD_RESET_REQUIRED,
    CLOSE_PASSWORD_RESET_REQUIRED,
    SHOW_RECAPTHA_IMAGE,
    SET_SHOW_SESSION_EXPIRY_OVERLAY
} from './ActionTypes';

import axios from 'axios';
import { getCurrentEnvironmentConfig, logger } from '../util/AppUtil';
import { getDynamicContent } from '../service/DynamicContentService';
import { getStore } from '../util/ReduxUtil';
// import { OmnitureUtil } from './../util/OmnitureUtil';

export function setQueryStringToState(parsedQueryString) {
    return { type: APP_SET_QUERY_STRING_TO_STATE, parsedQueryString };
}

export function setTranslator(translator) {
    return { type: APP_SET_TRANSLATOR, translator };
}

export function setPageLevelError(pageLevelErrorMessage, bypassOverrides) {
    if (pageLevelErrorMessage != null && !bypassOverrides) {
        if (getStore().getState().app.centralConfig.show_downtime_msg) {
            pageLevelErrorMessage = 'Sorry! Our site is experiencing issues at this time. Please try again.';
        }
    }
    return { type: APP_SET_PAGE_ERROR, pageLevelErrorMessage };
}

export function setUserDetailsToState(userDetails) {
    return { type: APP_SET_USER_DETAILS, userDetails };
}

export function setSignedOut(signedOut) {
    return { type: APP_SET_SIGNED_OUT, signedOut };
}

export function setIsChromeIncognito(isChromeIncognito) {
    return { type: APP_SET_IS_CHROME_INCOGNITO, isChromeIncognito };
}

export function setCentralConfig(centralConfig) {
    return { type: APP_SET_CENTRAL_CONFIG, centralConfig };
}

export function iplookup(ip, dispatch) {
    const { apigeeApiKey, apigeeBaseUrl } = getCurrentEnvironmentConfig();
    const config = {
        headers: { "SFLY-Apikey": apigeeApiKey }
    };
    return axios.get(`${apigeeBaseUrl}/user/iplookup?ip=${ip}`, config)
        .then((response) => {
            if (response.data) {
                const { countryCode, countryName, latitude, longitude, postalCode, regionCode, regionName } = response.data;
                dispatch({
                    type: APP_SET_GEO_INFORMATION,
                    geoInformation: { ip, countryCode, countryName, latitude, longitude, postalCode, regionCode, regionName }
                });
            }
        })
        .catch((e) => {
            logger.error({
                appContext: {
                    msg: `Failed to get information about ip address ${ip}`, error:e
                }
            });
        });
}

export function setGeoInfo(ip) {
    return (dispatch, getState) => {
        if (getState().app.geoInformation) {
            return Promise.resolve();
        }
        if (ip) {
            return iplookup(ip, dispatch);
        }
        // Call public endpoint to get the users IP
        return axios.get('https://api.ipify.org/?format=json')
            .then((response) => {
                if (response.data && response.data.ip) {
                    return iplookup(response.data.ip, dispatch);
                } else {
                    logger.error({
                        appContext: {
                            msg: "No ip address received from ipify."
                        }
                    });
                }
            })
            .catch((e) => {
                logger.error({
                    appContext: {
                        msg: "Failed to get the IP data.", error:e
                    }
                });
            });
    }
}

/**
 * Dynamic Contents
 */

export function setDynamicContent(contentSpaceName, dynamicContent, newDynamicContent, isRegularPage) {
    return (dispatch) => {
        if (!dynamicContent && contentSpaceName) {
            return getDynamicContent(contentSpaceName, newDynamicContent, getStore().getState().app.brand, isRegularPage)
                .then((dynamicContent) => {
                    dispatch({
                        type: APP_SET_DYNAMIC_CONTENT,
                        dynamicContent
                    });
                });
        }
        dispatch({
            type: APP_SET_DYNAMIC_CONTENT,
            dynamicContent
        });
    }
}

export function setIconSource(source) {
    return { type: SET_ICON_SOURCE, source };
}


// export const loadABTestConfig = () => {
//     return (dispatch) => {
//         OmnitureUtil.loadABTestConfig()
//             .then((response) => {
//                 dispatch({
//                     type: GET_AB_TEST_CONFIG,
//                     payload: response
//                 });
//             })
//             .catch((error) => {
//                 dispatch({
//                     type: GET_AB_TEST_CONFIG,
//                     payload: []
//                 });
//             })
//         }    
// }

// export const loadABTestConfigComplexPassword = (complexPassword) => {

//     /**
//      * Support so QA team can easily toggle between complex password
//      *  and default password based on url querystring `complexPassword`
//      */

//     if (complexPassword === 'false') {
//         return (dispatch) => {
//             dispatch({
//                 type: GET_AB_TEST_CONFIG_FULFILLED,
//                 payload: { newPasswordSecurity: false }
//             });
//         };
//     } else  {
//         return (dispatch) => {
//             dispatch({
//                 type: GET_AB_TEST_CONFIG_FULFILLED,
//                 payload: { newPasswordSecurity: true }
//             });
//         }
//     } 
//   }


// export const loadABTestConfigSignUp = (newSignUp) => {

//     /**
//      * Support so QA team can easily toggle between new sign up page and old sign up page 
//      *  based on url querystring `newSignUp`
//      */

//     if (newSignUp === 'false') {
//         return (dispatch) => {
//             dispatch({
//                 type: GET_AB_TEST_CONFIG_NEWSIGNUP_FULFILLED,
//                 payload: { newSignIn: false }
//             });
//         };
//     } else {
//         return (dispatch) => {
//             dispatch({
//                 type: GET_AB_TEST_CONFIG_NEWSIGNUP_FULFILLED,
//                 payload: { newSignIn: true }
//             });
//         }
//     }
// }


export const setUpdatePassword = (value) => {
    return { type: SET_UPDATE_PASSWORD, payload: value };
}

export function setPasswordResetRequired() {
    return {
        type: PASSWORD_RESET_REQUIRED
    }
}

export function closePasswordResetRequired() {
    return {
        type: CLOSE_PASSWORD_RESET_REQUIRED
    }
}
export function showRecapthaImage(payload) {
    return{
        type: SHOW_RECAPTHA_IMAGE,
        payload
    }
}

export const setSocialError = (error) => ({ type: SET_SOCIAL_ERROR, payload: error });

export const resetSocialError = () => ({ type: RESET_SOCIAL_ERROR });

export const setSocialLoginInProgress = inProgress => ({ type: SET_SOCIAL_LOGIN_IN_PROGRESS, payload: inProgress });

export const showExpiredlinkPopUp = (value) => ({ type: SET_EXPIREDLINK_POPUP, payload: value });

export const showMigratedlinkPopUp = (value) => ({ type: SET_MIGRATEDLINK_POPUP, payload: value });

export const toggleSessionExpiryOverlay = (value) => ({ type: SET_SHOW_SESSION_EXPIRY_OVERLAY, payload: value });



